import React from 'react';

const SnapLinesOverlay = ({ lines }) => {
  return (
    <div className="absolute inset-0 pointer-events-none z-[90]">
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {/* Infinite Line */}
          <div
            className="absolute bg-blue-500"
            style={{
              left: line.vertical ? line.x : -10000,
              top: !line.vertical ? line.y : -10000,
              width: line.vertical ? 1 : 20000, // Large width for horizontal line
              height: !line.vertical ? 1 : 20000, // Large height for vertical line
              backgroundColor: '#3b82f6', // blue-500
              opacity: 0.8
            }}
          />
          
          {/* Object Highlight */}
          {line.rect && (
            <div
              className="absolute bg-blue-500/10 border border-blue-500/30 transition-all duration-75"
              style={{
                left: line.rect.x,
                top: line.rect.y,
                width: line.rect.width,
                height: line.rect.height,
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SnapLinesOverlay;
